<template>
  <div class="applyFor">
    <van-sticky>
      <div
        class="applyForNav"
        :style="{ 'padding-top': (isiOSX ? 44 : 24) + 'px' }"
      >
        <img
          class="navLeft"
          @click="goBack()"
          src="./../../../assets/decoration/back.png"
        />
        <span class="navTitle">申请成为装饰代理人</span>
      </div>
    </van-sticky>
    <div class="content">
      <!-- 提示信息 -->
      <div class="applyFor_tip">
        根据相关法规要求，且为保护您的账号安全，须验证账号持有人的身份信息，确认用户所绑定的账号为本人持有
      </div>

      <!-- 申请人信息 -->
      <div class="card">
        <div class="title" :style="{ height: is_white ? '32px' : '22px' }">
          <div class="title_top">
            <img
              v-if="is_white"
              src="./../../../assets/decoration/type1.png"
              alt=""
            />
            <h3>{{ is_white ? "确认申请人信息" : "申请人信息" }}</h3>
          </div>
          <div
            class="bottom_line"
            :style="{ width: is_white ? '143px' : '81px' }"
          ></div>
        </div>
        <div class="item">
          <p>会员手机号</p>
          <span>{{ userData.phone }}</span>
        </div>
        <div class="item">
          <p>证件类型</p>
          <span v-if="userData.auth_type == 1">大陆身份证</span>
          <span v-if="userData.auth_type == 2">回乡证</span>
          <span v-if="userData.auth_type == 3">台胞证</span>
          <span v-if="userData.auth_type == 4">港澳台居民居住证</span>
          <span v-if="userData.auth_type == 5">外籍人永久居留身份证</span>
        </div>
        <div class="item">
          <p>真实姓名</p>
          <span>{{ userData.realname }}</span>
        </div>
        <div class="item">
          <p>证件号码</p>
          <span>{{ userData.id_number }}</span>
        </div>
      </div>
      <!-- 内容 -->
      <div class="card" v-if="!is_white">
        <div class="title" :style="{ height: '22px' }">
          <div class="title_top">
            <h3>内容</h3>
          </div>
          <div class="bottom_line" :style="{ width: '32px' }"></div>
        </div>
        <div class="item">
          <p>缴费金额</p>
          <span v-if="userData.config">￥{{ userData.config.agentCost }}</span>
        </div>
        <div class="item">
          <p>身份有效期</p>
          <span>1年</span>
        </div>
      </div>
      <!-- 上传凭证 -->
      <div class="card" v-if="is_white">
        <div class="title" :style="{ height: '32px' }">
          <div class="title_top">
            <img src="./../../../assets/decoration/type2.png" alt="" />
            <h3>上传缴费凭证</h3>
          </div>

          <div class="bottom_line" :style="{ width: '128px' }"></div>
        </div>
        <div class="item">
          <p>合同有效期</p>
          <span>{{ started_at }}~{{ ended_at }}</span>
        </div>
        <div class="item border-bottom">
          <p>已缴纳金额</p>
          <span>
            <van-field
              v-model="amount"
              type="digit"
              input-align="right"
              placeholder="请输入已缴费金额"
            />
          </span>
        </div>
        <div class="item upload">
          <div class="uploadTop">
            <p>缴费凭证</p>
            <p>{{ fileList.length }}/2</p>
          </div>
          <div class="uploadBtm">
            <van-uploader
              v-model="fileList"
              :max-count="2"
              :accept="accept"
              multiple
              :after-read="afterRead"
              :before-read="beforeRead"
            >
              <div class="box">
                <img src="./../../../assets/decoration/addImg.png" />
              </div>
            </van-uploader>
          </div>
        </div>
      </div>
    </div>
    <div
      class="agreement"
      v-if="!is_white"
      @click.stop="isAgreement = !isAgreement"
    >
      <img
        src="./../../../assets/decoration/uncheckedF.png"
        v-if="!isAgreement"
      />
      <img src="./../../../assets/decoration/checkedF.png" v-else />
      <p>
        我已经阅读并同意<span @click.stop="seeAgreement()"
          >《销巴装饰代理人合作须知》</span
        >
      </p>
    </div>
    <div class="btm">
      <div class="btn" @click="pay()" v-if="!is_white">立即申请</div>
      <div class="btn" @click="submit()" v-if="is_white">立即申请</div>
    </div>
    <div class="order-loading" v-if="payLoading">
      <img src="../../../assets/shared-hotel/loading.gif" />
    </div>
  </div>
</template>
<script>
import Upload from "./../../../providers/upload";
import dsbridge from "dsbridge";
export default {
  data() {
    return {
      isiOSX: false,
      payLoading: false,
      isAgreement: false,
      is_white: false, //false:不是白名单
      equipment: null, //10安卓，11ios
      started_at: "", //类型：String  必有字段  备注：有效期开始时间
      ended_at: "", //类型：String  必有字段  备注：有效期结束时间
      amount: "",
      fileList: [],
      userData: {},
      accept: "image/jpeg, image/jpg, image/png", //允许上传的图片类型
      ordersn: null,
    };
  },
  created() {
    this.isiOSX = this.isIphoneX();
    this.$api.setToken(JSON.parse(sessionStorage.getItem("token")));
    if (this.$route.query.is_white) {
      this.is_white = JSON.parse(this.$route.query.is_white);
    }
    this.deductionUA();
    if (this.is_white) {
      this.getWhiteValid();
    }
    this.getConfigData();
  },
  mounted() {
    window.setPay = this.setPay;
    window.decorationPayResult = this.decorationPayResult;
    window.decorateCancelPay = this.decorateCancelPay;
  },
  methods: {
    goBack() {
      this.$router.go(-1);
    },
    // 判断手机机型
    deductionUA() {
      const ua = navigator.userAgent.toLowerCase();
      if (/iphone|ipad|ipod/.test(ua)) {
        this.equipment = 11;
      } else if (/android/.test(ua)) {
        this.equipment = 10;
      }
    },
    // 获取白名单有效期
    getWhiteValid() {
      this.$api.post("decoration/member/white/valid").then((res) => {
        this.started_at = res.started_at;
        this.ended_at = res.ended_at;
      });
    },
    // 获取缴费金额和实名信息
    getConfigData() {
      this.$api
        .post("decoration/member/city/agent/get/money", {
          code: "agentCost",
          type: 1,
        })
        .then((res) => {
          this.userData = res;
        });
    },
    beforeRead(file) {
      if (file.size == 0 || JSON.stringify(file.file) == "{}") {
        //解决部分机型取消上传还是添加空白图片
        return false;
      } else {
        return true;
      }
    },
    afterRead(file) {
      if (Array.isArray(file)) {
        // 多选
        file.forEach((item) => {
          this.imgUpload(item);
        });
      } else {
        // 单选
        this.imgUpload(file);
      }
    },
    // 图片上传
    imgUpload(file) {
      file.status = "uploading";
      file.message = "上传中...";
      Upload.upload(file.file, ["others"])
        .then((res) => {
          file.status = "";
          file.message = "";
          file.src = res;
        })
        .catch((res) => {
          file.status = "failed";
          file.message = "失败";
        });
    },
    pay() {
      if (!this.isAgreement) {
        this.$toast("请先勾选《销巴装饰代理人合作须知》");
        return;
      }
      this.payLoading = true;
      //   创建代理人
      this.$api
        .post("decoration/member/city/agent/store", {
          payment_type: 2, //类型：Number  必有字段  备注：1:白名单首次录入,2:正常首次录入
          status: 1, //类型：Number  必有字段  备注：10：白名单，1：正常首次录入
          name: this.userData.realname, //类型：String  必有字段  备注：真实姓名
          id_number: this.userData.id_number, //类型：String  必有字段  备注：身份证号
          auth_type: this.userData.auth_type, //类型：String  必有字段  备注：证件类型 1大陆身份证、2回乡证、3台胞证、4港澳台居民居住证、5外籍人永久居留身份证
          amount: this.userData.config.agentCost, //类型：String  必有字段  备注：缴费金额
        })
        .then((res) => {
          // 更新代理人身份
          this.$api
            .post("decoration/member/city/agent/switch/role", {
              type: 1,
            })
            .then((res) => {});
          //   判断是否存在未支付订单
          this.$api
            .get("decoration/member/city/agent/wait/pay/order")
            .then((res) => {
              if (res.is_wait_pay_order) {
                this.payLoading = false;
                this.ordersn = res.data.order_sn;
                let param = {
                  actual_amount: res.data.amount,
                  order_amount: res.data.amount,
                  ordersn: res.data.order_sn,
                  order_type: "decoration_city_agent",
                };
                this.params(
                  JSON.stringify(param),
                  JSON.stringify(param),
                  "decorationPay"
                );
              } else {
                // 确认订单
                this.$api
                  .post("/order/member/order/confirm", {
                    order: {
                      type: "decoration_city_agent", //类型：String  必有字段  备注：订单类型
                    },
                  })
                  .then((confirmResult) => {
                    // 创建订单
                    this.$api
                      .post("/order/member/order/create", {
                        order: {
                          //类型：Object  必有字段  备注：主订单必传参数
                          type: "decoration_city_agent", //类型：String  必有字段  备注：订单类型
                          client: this.equipment, //类型：Number  必有字段  备注：客户端类型 10：安卓 11：APPIOS 12：wap 13：小程序 20：pc
                          confirm: confirmResult.order.confirm, //类型：Array  必有字段  备注：订单确认信息（以下信息有确认订单接口原封不动的返回即可）
                        },
                      })
                      .then((createResult) => {
                        this.payLoading = false;
                        this.ordersn = createResult.ordersn;
                        let param = {
                          actual_amount: createResult.actual_amount,
                          order_amount: createResult.order_amount,
                          ordersn: createResult.ordersn,
                          order_type: "decoration_city_agent",
                        };
                        this.params(
                          JSON.stringify(param),
                          JSON.stringify(param),
                          "decorationPay"
                        );
                      })
                      .catch((err) => {
                        this.payLoading = false;
                        this.ThrowError(err);
                      });
                  })
                  .catch((err) => {
                    this.payLoading = false;
                    this.ThrowError(err);
                  });
              }
            })
            .catch((err) => {
              this.payLoading = false;
              this.ThrowError(err);
            });
        })
        .catch((err) => {
          this.payLoading = false;
          this.ThrowError(err);
        });
    },
    // ios支付结果回调
    decorationPayResult() {
      this.setPay("success");
    },
    // 安卓支付结果回调
    setPay(res) {
      let result = false;
      if (res == "success") {
        result = true;
      } else {
        let data = JSON.parse(res);
        if (data.code == 0) {
          result = true;
        } else if (data.code == -1) {
          result = false;
          this.decorateCancelPay();
        }
      }
      // this.params("", "1", "decorateBackOff");
      if (result) {
        this.$router.push({
          path: "/decoration/deputy/payResult",
          query: {
            ordersn: this.ordersn,
            result: result,
          },
        });
      }
    },
    decorateCancelPay() {
      this.$router.push({
        path: "/decoration/deputy/details",
      });
    },
    submit() {
      let voucher = [];
      this.fileList.forEach((item) => {
        if (item.src) {
          voucher.push(item.src);
        } else {
          this.$toast("图片正在上传中，请稍等");
          return;
        }
      });
      this.payLoading = true;
      this.$api
        .post("decoration/member/city/agent/store", {
          payment_type: 1, //类型：Number  必有字段  备注：1:白名单首次录入,2:正常首次录入
          status: 10, //类型：Number  必有字段  备注：10：白名单，1：正常首次录入
          name: this.userData.realname, //类型：String  必有字段  备注：真实姓名
          id_number: this.userData.id_number, //类型：String  必有字段  备注：身份证号
          auth_type: this.userData.auth_type, //类型：String  必有字段  备注：证件类型 1大陆身份证、2回乡证、3台胞证、4港澳台居民居住证、5外籍人永久居留身份证
          started_at: this.started_at, //类型：String  必有字段  备注：有效期开始时间
          ended_at: this.ended_at, //类型：String  必有字段  备注：有效期结束时间
          voucher: voucher, //类型：Array  必有字段  备注：缴费凭证
          amount: this.amount, //类型：String  必有字段  备注：缴费金额
        })
        .then((res) => {
          // 更新代理人身份
          this.$api
            .post("decoration/member/city/agent/switch/role", {
              type: 1,
            })
            .then((res) => {
              // 跳转详情
              this.$router.push({
                path: "/decoration/deputy/details",
              });
              this.payLoading = false;
            });
        })
        .catch((err) => {
          this.ThrowError(err);
          this.payLoading = false;
        });
    },
    ThrowError(err) {
      let keys = Object.keys(err);
      let key = keys[0];
      let message = err.message || err[key][0];
      if (message.slice(0, 10) == "timeout of") {
        this.$toast("网络不给力，请稍候重试");
      } else {
        this.$toast(message);
      }
      return;
    },
    // 查看协议
    seeAgreement() {
      let url = `${window.location.protocol}//${
        window.location.host
      }/cms-agreement/detail?number=zsdlr1&entranceChannel=1&isApp=1&token=${JSON.parse(
        sessionStorage.getItem("token")
      )}`;
      window.location.href = url;
    },
  },
};
</script>
<style lang="less">
.applyFor {
  height: 100%;
  background: #f2f2f2;
  color: #333;
  padding-bottom: 125px;
  h3 {
    margin: 0;
  }
  .applyForNav {
    background: #ffffff;
    height: 44px;
    position: relative;
    .navLeft {
      width: 24px;
      height: 24px;
      position: absolute;
      left: 16px;
      bottom: 10px;
    }
    .navTitle {
      position: absolute;
      left: 50%;
      bottom: 10px;
      transform: translateX(-50%);
      font-size: 17px;
      font-weight: 700;
      color: #404247;
    }
  }
  //   内容
  .content {
    padding-bottom: 100px;
    .applyFor_tip {
      padding: 10px 13px;
      font-size: 14px;
      color: #ff7e31;
      line-height: 20px;
      background-color: rgba(255, 219, 198, 0.9);
    }
    .card {
      margin: 12px 16px 0;
      background: #ffffff;
      border-radius: 12px;
      padding: 24px 24px 32px;
      .title {
        padding-bottom: 2px;
        display: flex;
        position: relative;
        // border: 1px solid red;

        .title_top {
          position: absolute;
          bottom: 1px;
          left: 0;
          z-index: 2;
          display: flex;
          img {
            align-self: flex-end;
            width: 32px;
          }
          h3 {
            align-self: flex-end;
            font-size: 16px;
            font-weight: 600;
          }
        }
        .bottom_line {
          width: 100%;
          height: 5px;
          position: absolute;
          bottom: 0;
          left: -1px;
          background-color: #d2c3ff;
        }
      }
      .item {
        display: flex;
        justify-content: space-between;
        font-size: 15px;
        font-weight: 400;
        padding-top: 24px;
        p {
          color: #999999;
        }
        span {
          color: #333333;
          .van-cell {
            padding: 0;
            .van-field__control {
              width: 120px;
              font-size: 15px;
            }
          }
        }
      }
      .upload {
        flex-direction: column;
        .uploadTop {
          display: flex;
          justify-content: space-between;
        }
        .uploadBtm {
          display: flex;
          margin-top: 16px;
          img {
            width: 80px;
            height: 80px;
          }
          .van-uploader__preview {
            margin: 0 10px 0 0;
          }
        }
      }
      .border-bottom {
        border-bottom: 1px solid #f0f1ff;
        padding-bottom: 12px;
      }
    }
  }
  //   协议
  .agreement {
    width: 100%;
    padding: 12px 16px;
    background-color: #f2f2f2;
    position: fixed;
    left: 0;
    bottom: 83px;
    display: flex;
    font-size: 13px;
    color: #999999;
    line-height: 18px;
    img {
      width: 16px;
      height: 16px;
      margin-right: 8px;
    }
    p {
      flex: 1;
      span {
        color: #5853e9;
      }
    }
  }
  // 底部按钮
  .btm {
    width: 100%;
    height: 83px;
    background-color: #ffffff;
    position: fixed;
    left: 0;
    bottom: 0;
    display: flex;
    .btn {
      flex: 1;
      margin: 2px 17px 0;
      background-color: #5853e9;
      border-radius: 25px;
      height: 46px;
      line-height: 46px;
      text-align: center;
      color: #ffffff;
      font-size: 16px;
    }
  }
  .order-loading {
    text-align: center;
    position: fixed;
    top: 0;
    left: 0;
    z-index: 9999;
    width: 100%;
    height: 100%;
    background: rgba(0, 0, 0, 0.7);
    img {
      width: 35%;
      margin-top: 65%;
    }
  }
}
</style>